export const SESSION_NOT_FOUND_ERROR_MESSAGE = 'Sorry, we could not find your session. Please re-identify yourself.';
export const PARTIAL_PAYMENT_ERROR_MESSAGE =
	'Partial payment was done for this ticket. Contact your server to pay your ticket before leaving.';
export const TICKET_NOT_FOUND_ERROR_MESSAGE =
	'There was a problem initiating payment. Contact your server to pay for ticket before leaving.';
